import { useTranslation } from 'react-i18next';
import type { AlbumStyles } from '../../types';

interface Props {
  styles: AlbumStyles;
  value: string;
  disabled?: boolean;
  onChange: (theme: string) => void;
}

/** ADR-0048: the album's themes, each as its paper with its accent dot. */
export default function AlbumThemePicker({ styles, value, disabled = false, onChange }: Props) {
  const { t } = useTranslation();
  const bgColor = (id: string) => styles.backgrounds.find(b => b.id === id)?.color ?? '#fff';
  return (
    <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label={t('album.style.theme')}>
      {styles.themes.map(th => (
        <button
          key={th.id}
          role="radio"
          aria-checked={value === th.id}
          disabled={disabled}
          onClick={() => onChange(th.id)}
          className={`rounded-lg p-1.5 text-left cursor-pointer ${value === th.id ? 'ring-2 ring-teal-500' : 'ring-1 ring-slate-200 dark:ring-slate-700 hover:ring-teal-300'}`}
        >
          <span className="flex h-8 rounded-md overflow-hidden ring-1 ring-black/5" style={{ background: bgColor(th.background) }}>
            <span className="mt-auto ml-1.5 mb-1.5 h-2.5 w-2.5 rounded-full" style={{ background: th.accent }} />
          </span>
          <span className="block mt-1 text-[10px] text-slate-600 dark:text-slate-300 truncate">{t(`album.themes.${th.id}`, { defaultValue: th.id })}</span>
        </button>
      ))}
    </div>
  );
}
